module.exports = __webpack_public_path__ + "img/other_pay_easywallet.a40026b0.svg";